import TemplateDetail from '@/modules/templates/TemplateDetail'

export default function TemplateDetailPage() {
  return <TemplateDetail />
}
